import type TableView from "../store/schema/TableView";
import { type TableQueryType } from "../store/schema/TableQuery";
import { isSearchFolderScenario } from "../selectors/isSearchFolderScenario";
import type MailFolderTableQuery from "../store/schema/MailFolderTableQuery";
import { getParentFolderId } from "../selectors/mailRowDataPropertyGetter";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";

/**
 * @param tableView for which we want to get the context folder id
 * @return Returns folderId for the table view
 */
export default function getContextFolderIdForTable(tableView: TableView): string | undefined {
    switch (tableView.tableQuery.type) {
        case 0:
            const scenarioType = (tableView.tableQuery as MailFolderTableQuery).scenarioType;
            if (!isSearchFolderScenario(scenarioType)) {
                return tableView.tableQuery.folderId;
            }
            return tableView.serverFolderId;
        case 4:
            return tableView.tableQuery.folderId;
        case 3:
            return tableView.tableQuery.folderId.split("-").join("/").split("_").join("+");
        case 1:
        case 2:
        default:
            return undefined;
    }
}

/// This function is used to get the context folder id for items triage action
/// when the table view is a search folder and the action is performed on a single item
/// in the search folder. In this case, we need to get the parent folder id of the item
/// instead of the context folder id of the table view.
/// This is mostly used so we can perform undo actions on the item to its original folder
export function getContextFolderIdForItemsTriageAction(tableView: TableView, rowKeys: string[]): string | undefined {
    if (tableView.tableQuery.listViewType === 1 &&
        rowKeys.length === 1 &&
        tableView.tableQuery.type === 0 &&
        isSearchFolderScenario((tableView.tableQuery as MailFolderTableQuery).scenarioType)) {
        return getParentFolderId(rowKeys[0], tableView);
    }
    
    return getContextFolderIdForTable(tableView);
}
